import React, { useEffect } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useAuthenticationContext } from "../../../hooks/authentication/AuthenticationContext";
import { useExpertMessageContext } from "../../../hooks/expert-message/ExpertMessageContext";
import { useExpertTaskListContext } from "../../../hooks/expert-task-list/ExpertTaskListContext";
import { useMessagePass } from "../../../hooks/MessagePassHook";
import { useExpertProfileContext } from "../../../hooks/expert-profile/ExpertProfileContext";
import { INITIAL_MESSAGE_STATE } from "../../../hooks/expert-message/ExpertMessageHook";
const ExpertTaskList = ({
  children,
  disableTaskSelectionCheck = false
}) => {
  const {
    message,
    selectMessage,
    clearMessage,
    setMessage,
    getMessageResource
  } = useExpertMessageContext();
  const {
    fetchTaskList,
    tasklist,
    tasklistFilters,
    removeTasklistRecord,
    applyFiltersOnRefresh
  } = useExpertTaskListContext();
  const {
    profile
  } = useExpertProfileContext();
  const [selectedMessageId, setSelectedMessageId] = React.useState("");
  const {
    passTasklistMessage
  } = useMessagePass();
  const {
    isAuthenticated
  } = useAuthenticationContext();
  const log = pilog.getLogger("ExpertTaskList");
  useEffect(() => {
    if (isAuthenticated) {
      fetchTaskList(true);
    }
  }, [isAuthenticated]);
  useEffect(() => {
    if (!message.loading && (!message.messageId || message.hasError)) {
      setSelectedMessageId("");
    }
  }, [message.messageId, message.hasError, message]);
  const setClaimMessage = (messageInbox, callback) => {
    setSelectedMessageId(messageInbox.messageId);
    getMessageResource(messageInbox, profile, callback);
  };
  const handleSelectMessage = (messageInbox, callback) => {
    // disableTaskSelectionCheck - In EMA, the expert can access the last viewed message.
    if ((disableTaskSelectionCheck || selectedMessageId !== messageInbox.messageId) && !message.loading) {
      setSelectedMessageId(messageInbox.messageId);
      selectMessage(messageInbox, profile, callback);
    }
  };
  const handleRefreshTaskList = () => {
    applyFiltersOnRefresh();
    clearMessage();
  };
  const handleUnSelectMessage = () => {
    setSelectedMessageId("");
    setMessage(INITIAL_MESSAGE_STATE);
  };
  log.debug(tasklist);
  return children({
    loading: tasklist.loading || profile.loading,
    newMessageLoading: message.loading,
    hasMessages: Object.keys(tasklist.filteredMessages).length > 0,
    selectedMessageId,
    messages: tasklist.filteredMessages,
    messageCount: tasklist.count,
    filters: tasklistFilters,
    removeTasklistRecord,
    passTasklistMessage,
    onSelectMessage: handleSelectMessage,
    claimSelectedMessage: setClaimMessage,
    onTaskListRefresh: handleRefreshTaskList,
    activeFilterCount: tasklist.activeFilterCount,
    onUnselectMessage: handleUnSelectMessage
  });
};
export default ExpertTaskList;
ExpertTaskList.propTypes = {
  children: PropTypes.func.isRequired,
  disableTaskSelectionCheck: PropTypes.bool
};